import { fromAsync } from "../../async/static/fromAsync.js";
export const asAsync = (source) => {
    async function* generator() {
        for (const value of source) {
            yield value;
        }
    }
    return fromAsync(generator);
};
